import {Component, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute} from '@angular/router';
import {CommonService} from '../../../../services/common.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';

@Component({
    selector: 'app-log-details',
    templateUrl: './log-details.component.html',
    styleUrls: ['./log-details.component.scss']
})
export class LogDetailsComponent implements OnInit {
    consentId: number;
    uniqueToken: string;
    pageTitle: string;
    pageLoaded: boolean;
    details: MatTableDataSource<any>;
    columnsToDisplay = ['event_description', 'action_date', 'parent', 'previous_value', 'value'];
    isLoading: boolean;
    tableHeight: number;
    mode: number;

    constructor(private route: ActivatedRoute, public commonService: CommonService, public toastMessagesService: ToastMessagesService) {
    }

    ngOnInit(): void {
        this.pageLoaded = false;
        this.route.queryParams.subscribe(async (params) => {
            this.mode = +params.mode;
            this.consentId = params.id;
            this.uniqueToken = params.token;
            this.pageTitle = +params.mode === 1 ? `Ιστορικό για την συναίνεση ${this.uniqueToken}` : `Ιστορικό για την εγγραφή ${this.uniqueToken}`;
            this.pageLoaded = true;
            this.isLoading = true;
            this.tableHeight = window.innerHeight - 272;
            if (+params.mode === 1) {
                await this.initLogDetails();
            }
            if (+params.mode === 2) {
                await this.initAffirmationLogDetails();
            }
        });
    }

    private async initLogDetails() {
        try {
            const detailsRequest = await this.commonService.getList(`consents/logs/details?consent_id=${this.consentId}&token=${this.uniqueToken}`);
            console.log(detailsRequest.object);
            this.details = new MatTableDataSource<any>(detailsRequest.object);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    private async initAffirmationLogDetails() {
        try {
            const detailsRequest = await this.commonService.getList(`affirmations/logs/details?id=${this.consentId}&token=${this.uniqueToken}`);
            console.log(detailsRequest.object);
            this.details = new MatTableDataSource<any>(detailsRequest.object);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }
}
